Ext.define('SA.Filter', {
    statics: {
        and(...predicates) {
            return new SA.Filter('and', predicates);
        },

        or(...predicates) {
            return new SA.Filter('or', predicates);
        }
    },

    constructor(aggregateOperator, predicates) {
        this.aggregateOperator = aggregateOperator;
        this.predicates = predicates;
    },

    getAggregateOperator() {
        return this.aggregateOperator;
    },

    getAttributes() {
        return SA.Array.unique(this.getPredicates().map(predicate => predicate.getAttribute()));
    },

    getPredicates() {
        return this.predicates;
    },

    isAnd() {
        return this.getAggregateOperator() === 'and';
    },

    isOr() {
        return this.getAggregateOperator() === 'or';
    }
});